module.exports = __webpack_public_path__ + "img/icon_duoduo_p.24674706.png";